import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Transaction } from '../../../../models';
import dayjs from 'dayjs'

import AppLink from '../../../../components/AppLink';
import { to2DecimalPlaces } from '../../../../helpers';
import { ROUTES } from '../../../../history';


const TransactionListWidget: React.FC<{
    transaction: Transaction;
    active?: boolean;

   
    onClickCheck?: (p: Transaction) => void;

}> = ({ transaction, active = false,  onClickCheck }) => {
        return (
            <TableRow >
            <TableCell component="th" scope="row">
                    <Box display="flex" alignItems={'center'}>
                        <Box display="inline-block" sx={{
                            mr: 1
                        }}>
             
                          </Box>
                    <AppLink doNotUseButton to={ROUTES.ADMIN_BASE +  "/transactions/view/" + transaction.id}>   <Typography component="span" fontSize="14px" fontWeight={"bold"}>   {dayjs(transaction.createdAt).format("MMM D, YYYY")}
                        </Typography>  </AppLink>     </Box>
                </TableCell> 
                <TableCell align="right">
                    {to2DecimalPlaces(transaction.Amount/100)}
                </TableCell>
                <TableCell align="right">
                    {transaction.Status}
                </TableCell>
                <TableCell align="right">
                    {transaction.TypeOfTransaction}
                </TableCell>
                <TableCell align="right">
                    {transaction.payStackReference || "NONE"}
                </TableCell>
          
            </TableRow>
        );
 

    
}

export default TransactionListWidget;
